module.exports = __webpack_public_path__ + "static/media/vegitables_54.a05d7f25.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_54.csv
// module id = 640
// module chunks = 0